import React, { useEffect, useRef, useState } from 'react'
import { BsEye, BsXLg } from "react-icons/bs";
import { BsEyeSlash } from "react-icons/bs";
import "./LoginForm.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AiOutlineUser } from "react-icons/ai";
import { BiLock, BiRefresh } from "react-icons/bi";
import leftImg from "../../../assets/images/bg-down.png"
import rightImg from "../../../assets/images/bg-up.png"
import { GetLocalStorageParsed, ImageurlIcons, SetLocalStorage, SetLocalStorageStringify, validateonChangeHandle, validateonKeyUpHandle } from '../../../Utils/Utils';
import { useLanguage } from '../../LanguageProvider/LanguageProvider ';
import { login, getMobileExistence, clearCache } from '../../../services/api/auth';
const LoginForm = ({ loginFormData, buttData, formData, setLoginFormData }) => {
    const { language, setLanguage } = useLanguage();
    const [errorMessage, setErrorMessage] = useState();
    const [loginFailedAttempt, setLoginFailedAttempt] = useState();
    const [emptyClickMessage, setEmptyClickMessage] = useState();
    const getWithoutLoginSubCatClick = GetLocalStorageParsed("subCategoryClick")
    const location = useLocation();
    const [loginMessage, setLoginMessage] = useState(false);
    const [captcha, setCaptcha] = useState("");
    const [captchaWrongMessage, setCaptchaWrongMessage] = useState();

    useEffect(() => {
        generateCaptcha();
        if (location.state === "password-reset") {
            setLoginMessage(true);
            navigate(location.pathname, { replace: true });
            const timer = setTimeout(() => {
                setLoginMessage(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, []);

    //states
    const navigate = useNavigate()
    const [loginDetail, setLoginDetail] = useState({
        mobile_number: "",
        password: ""
    })
    const [loginError, setLoginError] = useState({
        mobile_number: "",
        password: ""
    })
    const [passwordVisible, setPasswordVisile] = useState(false);
    const handleClearCache = () => {

        clearCache().then(res => {

        }).catch((error) => {
        });

        // const option = {
        //     method: "GET",
        //     headers: {
        //         "access-control-allow-origin": "*",
        //         "content-type": "application/json",
        //     },
        //     url: `${Apiurl()}/clear-cache`,
        // };
        // axios(option)
        //     .then((e) => {

        //     })
        //     .catch((error) => {
        //     });
    }
    //login function

    const handleSubmitLogin = async () => {

        if (!allFieldsValid()) {
            return;
        }

        handleClearCache();
        const data = await loginFormData?.filter((l) => l.status == "1")?.find(item => item?.name_en.toLowerCase().includes("mobile"));
        if (data) {
            const exists = await fetchMobileExistence(data?.value);
            if (exists?.status == 400) {
                setLoginFormData(prevData =>
                    prevData.map(i =>
                        i.id === data.id ? { ...i, error: { hi: "मोबाइल नंबर/उपयोगकर्ता नाम हमारे रिकॉर्ड में नहीं मिला।", en: "Mobile Number/UserName not found in our records." } } : i
                    )
                );
            } else {
                setLoginFormData(prevData =>
                    prevData.map(i =>
                        i.id === data.id ? { ...i, error: "" } : i
                    )
                );
                try {
                    const formData = new FormData();
                    loginFormData?.filter((l) => l.status == "1")?.forEach(i => {
                        if (i?.value) {
                            formData.append([i.input_field_name], i?.value);
                        }
                    });
                    // formData.append("password", loginDetail.password);
                    //  const response = login(formData);  //axios.post(`${Apiurl()}/login`, formData);
                    login(formData).then(response => {
                        if (response?.status === 200 && response?.data?.failed_login_attempts || response?.status === 400) {
                            setErrorMessage(response?.data?.failed_login_attempts > 0 || response?.messages?.english?.toLowerCase()?.includes("account has been deactivated") ? response?.messages : { english: "Please check the details and try again.", hindi: "कृपया विवरण जांचें और पुनः प्रयास करें।" })
                            setLoginFailedAttempt(response?.data)
                            if (response?.data?.failed_login_attempts === 5) {
                                setTimeout(() => {
                                    navigate("/forgot-password")
                                }, 2000);
                            }
                            return;
                        } else if (response?.status === 200) {
                            SetLocalStorage("userInfo", response?.data?.token)
                            SetLocalStorageStringify("userDetail", response?.data?.user)
                            SetLocalStorage("userPermission", response?.data?.user?.permissions)
                            SetLocalStorage("user_type", response?.data?.user?.roles);
                            SetLocalStorageStringify("tokenExpiry", response?.data?.expire_at)
                            if (response?.data?.user?.roles === 'superadmin' || response?.data?.user?.user_type === '1') {
                                navigate("/admin")
                            } else {
                                navigate("/dashboard")
                            }
                        } else {
                            setErrorMessage({ english: "Please check the details and try again.", hindi: "कृपया विवरण जांचें और पुनः प्रयास करें।" })
                        }
                    }).catch((error) => {
                    });

                } catch (error) {
                }
            }
        }
    }
    const fetchMobileExistence = async (i) => {
        try {
            const formData = new FormData();
            formData.append("mobile_number", i);

            return getMobileExistence(formData).then(res => {
                if (res) {
                    return res
                }
            }).catch(err => {

            });

            // const reponse = await axios.post(`${Apiurl()}/is-email-mobileno-exists`, formData);
            // return reponse?.data
        } catch (error) {
        }
    }
    useEffect(() => {
        if (errorMessage || language) {
            setEmptyClickMessage({ hi: errorMessage?.hindi, en: errorMessage?.english })
        }
    }, [errorMessage, language])
    const allFieldsValid = () => {
        return loginFormData?.filter((l) => l.status == "1")?.every(item => item.value && item.error === "") && captchaWrongMessage == "";
    };
    const hadleShowMessgae = () => {
        if (loginFormData?.filter((l) => l.status == "1")?.every(item => item.error === "") && captchaWrongMessage == "") {
            setEmptyClickMessage({ hi: "कृपया विवरण जांचें और पुनः प्रयास करें।", en: "Please check the details and try again." })
        } else {
            if (captchaWrongMessage !== "") {
                setLoginFormData(prevData =>
                    prevData.map(i =>
                        i.name_en?.toLowerCase()?.includes("captcha") ? { ...i, value: "" } : i
                    )
                );
                setCaptchaWrongMessage("")
                generateCaptcha()
            }
        }
    }

    const generateCaptcha = () => {
        const characters = "ABCDEFGHJKLMNPQRSTUVWXYZ123456789";
        let result = "";
        const charactersLength = characters.length;

        for (let i = 0; i < 6; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        setCaptcha(result);
        setLoginFormData(prevData =>
            prevData.map(i =>
                i.name_en?.toLowerCase()?.includes("captcha") ? { ...i, value: "", error: "" } : i
            )
        );
        setCaptchaWrongMessage("")
    };

    return (

        <section className=' main-outer-container'>

            <img src={leftImg} alt="background-image" className='main-bg-imgleft' />
            <img src={rightImg} alt="background-image" className='main-bg-imgright' />
            <div className='container'>
                <div className='row lf-row d-flex justify-content-center align-items-center'>
                    {loginMessage && (
                        <div className="col-md-8 lf-col p-0 border-0">
                            <div className="dc-reg-msg">
                                {" "}
                                {language ? "पासवर्ड रीसेट सफलतापूर्वक" : "Password Reset Successfully"} {" "}
                                <span
                                    onClick={() => {
                                        setLoginMessage(false);
                                    }}
                                >
                                    <BsXLg />
                                </span>
                            </div>
                        </div>
                    )}
                    <div className="col-md-8 lf-col p-0">
                        <div className="lf-outer-con">
                            {formData?.map((i, index) => (<h2 key={index + 1} style={{ backgroundColor: i?.background_color, fontSize: `${i?.font_size}px`, color: i?.font_color, padding: "5px", textAlign: "center" }} className='lf-heading'>{language ? i?.name_hi : i?.name_en}</h2>))}
                            <div className="lf-inner">
                                <div className="lf-outer">
                                    {/* mobile_number */}
                                    {/* <form autoComplete='off'> */}
                                    {loginFormData?.filter((l) => l.status == "1")?.map((item, index) => {
                                        return (
                                            <div className='lf-input-box mb-4' key={index + 1} onClick={() => { setEmptyClickMessage(""); setLoginFailedAttempt(); }}>
                                                <div className={`used-icon-password-visible ${item?.name_en?.toLowerCase()?.includes("captcha") ? ' d-flex' : ''}`} key={item.id}>
                                                    {item?.icon ? <img className='lg-input-icon' src={`${ImageurlIcons()}/${item?.icon}`} alt="" /> : <></>}
                                                    <input
                                                        className={item?.name_en?.toLowerCase()?.includes("captcha") ? 'w-50' : 'w-100'}
                                                        placeholder={language ? item?.placeholder_hi : item?.placeholder_en}
                                                        // type={item?.type == "password" ? `${passwordVisible ? 'text' : "password"}` : item?.type}
                                                        type='text'
                                                        style={item?.type === "password" ? { WebkitTextSecurity: passwordVisible ? "none" : "disc" } : {}}
                                                        autoComplete='one-time-code' // To disable the autocomplete on all text fields incldugin password
                                                        name={item?.input_field_name}
                                                        value={item?.name_en?.toLowerCase()?.includes("captcha") ? item?.value?.toUpperCase() : item?.value}
                                                        autoSuggestion="off"
                                                        onChange={(e) => {
                                                            setCaptchaWrongMessage("")
                                                            const cursorPosition = e.target.selectionStart;
                                                            if (!/^[a-zA-Z0-9\s]*$/.test(e?.target?.value) && item?.name_en?.toLowerCase()?.includes("captcha")) {
                                                                return;
                                                            }
                                                            const updatedFields = loginFormData.map(field => {
                                                                if (field.id === item?.id) {
                                                                    return {
                                                                        ...field,
                                                                        value: e?.target?.value
                                                                    };
                                                                }
                                                                return field;
                                                            });
                                                            setLoginFormData(updatedFields);
                                                            validateonChangeHandle(item, e, loginFormData, setLoginFormData);
                                                            setLoginFailedAttempt("")

                                                            if (item?.name_en?.toLowerCase()?.includes("captcha") && e?.target?.value?.length >= 6) {
                                                                if (captcha !== e?.target?.value.toUpperCase()) {
                                                                    setCaptchaWrongMessage({
                                                                        hi: "कैप्चा मेल नहीं खाया",
                                                                        en: "Captcha did not match",
                                                                    });
                                                                }
                                                            }
                                                            setTimeout(() => {
                                                                e.target.setSelectionRange(cursorPosition, cursorPosition);
                                                            }, 0);
                                                        }}
                                                        onInput={(e) => {
                                                            const inputValue = e.target.value;
                                                            if (/^\d+$/.test(inputValue) && inputValue.length > 10) {
                                                                e.target.value = inputValue.slice(0, 10);
                                                            }
                                                        }}
                                                        onKeyUp={(e) => { validateonKeyUpHandle(item, e.target.value, loginFormData, setLoginFormData) }}
                                                    />
                                                    {
                                                        item?.type == "password" ? <>
                                                            {
                                                                passwordVisible ?
                                                                    <BsEye className="icon-password-visible" onClick={() => setPasswordVisile(!passwordVisible)} /> :
                                                                    <BsEyeSlash className="icon-password-visible" onClick={() => setPasswordVisile(!passwordVisible)} />
                                                            }
                                                        </> : null
                                                    }
                                                    {item?.name_en?.toLowerCase()?.includes("captcha") ? <><div className="input_field captch_box ps-3 col-md-6">
                                                        <input
                                                            type="text"
                                                            className="generatedCaptcha"
                                                            name="box"
                                                            disabled
                                                            value={captcha}
                                                        />
                                                        <BiRefresh
                                                            onClick={generateCaptcha}
                                                            className="suf-captcha"
                                                        />
                                                        <input
                                                            type="hidden"
                                                            id="storedData"
                                                            name="storedData"
                                                            value={captcha}
                                                        />
                                                    </div> </> : null}
                                                    {item?.error?.en && !item?.name_en?.toLowerCase()?.includes("captcha") && <p className='validate-error'>{language ? item?.error?.hi : item?.error?.en}</p>}
                                                </div>
                                                {item?.name_en?.toLowerCase()?.includes("captcha") && item?.error?.en && <p className='validate-error'>{language ? item?.error?.hi : item?.error?.en}</p>}
                                                {item?.name_en?.toLowerCase()?.includes("captcha") && captchaWrongMessage && <p className='validate-error'>{language ? captchaWrongMessage?.hi : captchaWrongMessage?.en}</p>}
                                            </div>
                                        );
                                    })}
                                    {/* </form> */}
                                    <p className='validate-error text-center mb-2'>
                                        {language ? emptyClickMessage?.hi : emptyClickMessage?.en}
                                    </p>
                                    {/* {loginFailedAttempt?.block_time && <p className='validate-error'>{language ? `आप ${loginFailedAttempt?.block_time} के बाद दोबारा लॉगइन कर सकते हैं` : `You can again login after ${loginFailedAttempt?.block_time}`}</p>}                                    Remember me */}
                                    {buttData?.map((butt, index) => {
                                        const text = language ? butt?.name_hi : butt?.name_en;
                                        // Regex for matching "Register" or "Signup" for both Hindi and English
                                        const regex = language
                                            ? /पंजीकरण|साइन\s*अप/i
                                            : /register|sign\s*up|signup/i;

                                        const match = text.match(regex);

                                        const beforeText = match ? text.substring(0, match.index) : text;
                                        const matchedText = match ? match[0] : '';
                                        const afterText = match ? text.substring(match.index + match[0].length) : '';

                                        return (
                                            <div key={index}>
                                                {butt?.id === 4 ?
                                                    <>
                                                        <div key={index + 1} className='lf-remember-box'>
                                                            <Link style={{ backgroundColor: butt?.background_color, fontSize: `${butt?.font_size}px`, color: butt?.font_color, padding: "5px", textAlign: "center" }} to="/forgot-password">{language ? butt?.name_hi : butt?.name_en}</Link>
                                                        </div>
                                                    </>
                                                    :
                                                    butt?.id === 3 ?
                                                        <>
                                                            {
                                                                !allFieldsValid() ? <div key={index + 1} className="lf-btn">
                                                                    <button style={{ backgroundColor: butt?.background_color, fontSize: `${butt?.font_size}px`, color: butt?.font_color, padding: "10px", textAlign: "center" }} onClick={hadleShowMessgae}>{language ? butt?.name_hi : butt?.name_en}</button>
                                                                </div> : <div key={index + 1} className="lf-btn">
                                                                    <button style={{ backgroundColor: butt?.background_color, fontSize: `${butt?.font_size}px`, color: butt?.font_color, padding: "10px", textAlign: "center" }} onClick={handleSubmitLogin}>{language ? butt?.name_hi : butt?.name_en}</button>
                                                                </div>
                                                            }
                                                        </>
                                                        :
                                                        butt?.id === 5 ?
                                                            <div key={index + 1} className='lf-last'>
                                                                {match ? (
                                                                    <>
                                                                        <p style={{ backgroundColor: butt?.background_color, fontSize: `${butt?.font_size}px`, color: butt?.font_color, padding: "5px", textAlign: "center" }} >{beforeText}
                                                                            <Link style={{ backgroundColor: butt?.background_color, fontSize: `${butt?.font_size}px`, color: butt?.font_color, padding: "5px", textAlign: "center" }} to="/signup">{matchedText}</Link>
                                                                            {afterText}</p>
                                                                    </>
                                                                ) : (
                                                                    <p><Link to="/signup">{language ? butt?.name_hi : butt?.name_en}</Link></p>
                                                                )}
                                                            </div>
                                                            : null
                                                }
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    )
}
export default LoginForm 
